export default __webpack_public_path__ + "static/media/EmmyLovelace.3e22af36.png";